import React, { useState } from 'react';
import Login from './Login';
import './login.css'


export default function Register() {

  return (
    <div>
        <Login />        
    </div>
  )
}
